import React, { useState } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const OffersManager = ({siteData, refetch}) => {
  const [offers, setOffers] = useState( siteData&&siteData.offers[0]? [...siteData?.offers
    
  ]:[{
      site: siteData?.ID, // Static site ID
      offer: '',
      description: '',
      active: true
    }]);
 const [processing, setProcessing] = useState(false);
const [active,setActive]=useState('')

  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updated = [...offers];

    if (type === 'checkbox' && name === 'active') {
      updated[index][name] = checked;
    } else {
      updated[index][name] = value;
    }

    setOffers(updated);
  };

  const handleAddOffer = () => {
    setOffers([
      ...offers,
      {
        site: siteData?.ID,
        offer: '',
        description: '',
        active: true
      }
    ]);
  };

  const handleSubmit = async (index) => {
    const formData = new FormData();
    const offer = offers[index];
setActive(index)

const requiredFields = ['offer', 'description'];
  const missingFields = requiredFields.filter((field) => !offer[field]?.toString().trim());


  if (missingFields.length > 0) {
    toast.error(`Offer #${index + 1}: Please fill ${missingFields.join(', ')}`);
    return;
  }
    Object.entries(offer).forEach(([key, value]) => {
      formData.append(key, value);
    });
setProcessing(true);

 try {
       if (offer.id) {

        
              formData.append('id', offer.id);

              
              await api.put('offer-v2', formData);
              toast.success(`Offer #${index + 1} updated`);
            } else {
              await api.post('offer-v2', formData);
      toast.success(`Offer #${index + 1} created`);
            }
      
            refetch?.();
     
    } catch (err) {
      console.error(err);
      toast.error(`Error creating offer #${index + 1}`);
    }
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">Manage Offers</Typography>

      {offers.map((offerItem, index) => (
        <Paper
          key={index}
          style={{ padding: 16, marginBottom: 20, background: '#f9f9f9' }}
        >
          <Typography variant="subtitle1">Offer #{index + 1}</Typography>
          <Grid container spacing={2}>
          <Grid item xs={12} style={{textAlign:'right'}} sm={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={offerItem.active}
                    onChange={(e) => handleChange(index, e)}
                    name="active"
                    color="primary"
                  />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Offer Title"
                name="offer"
                value={offerItem.offer}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* Active Switch */}
           

            {/* Description */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Description"
                name="description"
                value={offerItem.description}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSubmit(index)}
              >
 {processing&&index===active
                  ? 'Processing...'
                  : offerItem.id
                  ? `Update Offer #${index + 1}`
                  : `Submit Offer #${index + 1}`}              </Button>
            </Grid>
          </Grid>
        </Paper>
      ))}

      {/* Add New Offer Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddOffer}
      >
        + Add Offer
      </Button>
    </Paper>
  );
};

export default OffersManager;
